export default {"src":"/_next/static/image/public/images/ic_error.41b543f60bc941c2bed74b943c4557a6.svg","height":18,"width":18};